
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4ff2"];
var parcelRegister = parcelRequire.register;
parcelRegister("8DoyF", function(module, exports) {

$parcel$export(module.exports, "CardType", function () { return $c81b20652fad2e13$export$f1a79bffad3377cd; });
$parcel$export(module.exports, "CardList", function () { return $c81b20652fad2e13$export$bb29c16f5612603e; });
$parcel$export(module.exports, "Card", function () { return $c81b20652fad2e13$export$60332b2344f7fe41; });
$parcel$export(module.exports, "ExternalLinkFlag", function () { return $c81b20652fad2e13$export$53f216714f50123e; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $15X7d = parcelRequire("15X7d");

var $1mmhu = parcelRequire("1mmhu");

var $cFufl = parcelRequire("cFufl");

var $ijssf = parcelRequire("ijssf");

var $c8Swp = parcelRequire("c8Swp");

var $5p1nv = parcelRequire("5p1nv");

var $e3PN2 = parcelRequire("e3PN2");

var $lt7JL = parcelRequire("lt7JL");

var $b6PLb = parcelRequire("b6PLb");

var $1fwGm = parcelRequire("1fwGm");

var $lWOSY = parcelRequire("lWOSY");

var $lCGzm = parcelRequire("lCGzm");

var $c81b20652fad2e13$export$f1a79bffad3377cd;
(function(CardType) {
    CardType["CLASSIC"] = "classic";
    CardType["COVER"] = "cover";
    CardType["FEATURED"] = "featured";
    CardType["HORIZONTALINFO"] = "horizontal-info";
    CardType["FLAG"] = "flag";
})($c81b20652fad2e13$export$f1a79bffad3377cd || ($c81b20652fad2e13$export$f1a79bffad3377cd = {}));
const $c81b20652fad2e13$export$bb29c16f5612603e = (0, $1mmhu.default).ol`
  ${(0, $15X7d.listReset)()}
  grid-column: 1 / -1;
  display: grid;
  gap: ${(0, $lCGzm.variableGlsp)()};
  grid-template-columns: repeat(1, 1fr);

  ${(0, $15X7d.media).mediumUp`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${(0, $15X7d.media).largeUp`
    grid-template-columns: repeat(3, 1fr);
  `}

  > li {
    min-width: 0;
  }
`;
const $c81b20652fad2e13$export$e9897d434e0741ee = (0, $1mmhu.default).div`
  display: flex;
  flex-flow: row nowrap;
  gap: ${(0, $lCGzm.variableGlsp)(0.5)};
  padding: ${(0, $lCGzm.variableGlsp)()};

  &:not(:first-child) {
    padding-top: 0;
    margin-top: ${(0, $lCGzm.variableGlsp)(-0.5)};
  }

  button {
    pointer-events: all;
  }
`;
function $c81b20652fad2e13$export$2e2bcd8739ae039(data) {
    const { cardType: cardType = "classic", className: className, linkLabel: linkLabel, onCardClickCapture: onCardClickCapture } = data;
    const { Link: Link } = (0, $lWOSY.useVedaUI)();
    // For backwards compatibility with deprecated props
    const to = "to" in data && data.to || data.linkTo || data.linkProperties?.linkTo;
    const isExternalLink = to ? $b6PLb.isExternalLink(to) : false;
    const cardData = {
        isExternalLink: isExternalLink,
        ...data
    };
    const defineBaseProps = ()=>{
        const baseProps = {
            className: className,
            linkLabel: linkLabel,
            onClickCapture: onCardClickCapture
        };
        if (cardType === "classic") {
            baseProps["as"] = (0, $ijssf.ClassicCardItem);
            baseProps["children"] = /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $ijssf.default), {
                ...cardData
            });
        } else if (cardType === "cover") {
            baseProps["as"] = (0, $c8Swp.CoverCardItem);
            baseProps["children"] = /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $c8Swp.default), {
                ...cardData
            });
        } else if (cardType === "featured") {
            baseProps["as"] = (0, $5p1nv.FeaturedCardItem);
            baseProps["children"] = /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $5p1nv.default), {
                ...cardData
            });
        } else if (cardType === "horizontal-info") {
            baseProps["as"] = (0, $e3PN2.HorizontalInfoCardItem);
            baseProps["children"] = /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $e3PN2.default), {
                title: data.title,
                description: data.description,
                imgSrc: data.imgSrc,
                imgAlt: data.imgAlt,
                tagLabels: data.tagLabels
            });
        } else if (cardType === "flag" && data.imgSrc && data.imgAlt && data.description && data.footerContent && data.title) {
            baseProps["uswds"] = true;
            baseProps["children"] = /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $lt7JL.default), {
                imgSrc: data.imgSrc,
                imgAlt: data.imgAlt,
                heading: data.title,
                description: data.description,
                footer: data.footerContent,
                cardLabel: "data_collection"
            });
        }
        return baseProps;
    };
    const baseProps = defineBaseProps();
    // Link variant
    if (to) {
        if (baseProps["uswds"]) return /*#__PURE__*/ (0, $iGQ0X.jsx)($c81b20652fad2e13$var$CardLinkWrapper, {
            to: to,
            children: baseProps["children"]
        });
        return /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1fwGm.ElementInteractive), {
            ...baseProps,
            linkProps: {
                as: Link,
                to: to
            }
        });
    }
    // Clickable variant
    if ("onClick" in data && data.onClick) return /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1fwGm.ElementInteractive), {
        ...baseProps,
        onClick: data.onClick
    });
    // Non-interactive variant
    return /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1fwGm.ElementInteractive), {
        ...baseProps
    });
}
const $c81b20652fad2e13$export$60332b2344f7fe41 = (0, $1mmhu.default)($c81b20652fad2e13$export$2e2bcd8739ae039)`
  /* Convert to styled-component: https://styled-components.com/docs/advanced#caveat */
`;
const $c81b20652fad2e13$var$ExternalLinkMark = (0, $1mmhu.default).div`
  display: flex;
  align-items: center;
  position: absolute;
  top: ${(0, $lCGzm.variableGlsp)(0.25)};
  right: ${(0, $lCGzm.variableGlsp)(0.25)};
  padding: ${(0, $lCGzm.variableGlsp)(0.125)} ${(0, $lCGzm.variableGlsp)(0.25)};
  background-color: ${(0, $15X7d.themeVal)("color.primary")};
  color: ${(0, $15X7d.themeVal)("color.surface")};
  text-transform: none;
  border-radius: calc(
    ${(0, $15X7d.multiply)((0, $15X7d.themeVal)("shape.rounded"), 2)} - ${(0, $lCGzm.variableGlsp)(0.125)}
  );
  z-index: 1;
`;
const $c81b20652fad2e13$var$FlagText = (0, $1mmhu.default).div`
  display: inline;
  font-weight: bold;
  font-size: 0.825rem;
  margin-right: ${(0, $lCGzm.variableGlsp)(0.25)};
`;
function $c81b20652fad2e13$export$53f216714f50123e() {
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)($c81b20652fad2e13$var$ExternalLinkMark, {
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)($c81b20652fad2e13$var$FlagText, {
                children: "External Link"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cFufl.CollecticonExpandTopRight), {
                size: "small",
                meaningful: false
            })
        ]
    });
}
function $c81b20652fad2e13$var$CardLinkWrapper({ children: children, to: to }) {
    const { Link: Link } = (0, $lWOSY.useVedaUI)();
    return /*#__PURE__*/ (0, $iGQ0X.jsx)(Link, {
        className: "card-a11y-states",
        to: to,
        style: {
            width: "100%",
            margin: 0,
            padding: 0,
            overflow: "hidden",
            borderRadius: "0.5rem"
        },
        children: children
    });
}

});
parcelRegister("ijssf", function(module, exports) {

$parcel$export(module.exports, "ClassicCardItem", function () { return $ec97727322b40291$export$82f1d6fba29f2c6b; });
$parcel$export(module.exports, "default", function () { return $ec97727322b40291$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $lAMhd = parcelRequire("lAMhd");

var $1mmhu = parcelRequire("1mmhu");

var $azHi1 = parcelRequire("azHi1");

var $8DoyF = parcelRequire("8DoyF");

var $lWOSY = parcelRequire("lWOSY");
const $ec97727322b40291$export$82f1d6fba29f2c6b = (0, $1mmhu.default)((0, $azHi1.CardItem))`
  background: transparent;
`;
function $ec97727322b40291$export$2e2bcd8739ae039(props) {
    const { title: title, description: description, date: date, overline: overline, imgSrc: imgSrc, imgAlt: imgAlt, parentTo: parentTo, tagLabels: tagLabels, footerContent: footerContent, hideExternalLinkBadge: hideExternalLinkBadge } = props;
    let isExternalLink;
    if ("isExternalLink" in props) ({ isExternalLink: isExternalLink } = props);
    const { Link: Link } = (0, $lWOSY.useVedaUI)();
    const CardContent = /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardHeader), {
                children: /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $azHi1.CardHeadline), {
                    children: [
                        /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardTitle), {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $azHi1.CardOverline), {
                            as: "div",
                            children: [
                                hideExternalLinkBadge !== true && isExternalLink && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $8DoyF.ExternalLinkFlag), {}),
                                !isExternalLink && tagLabels && parentTo && tagLabels.map((label)=>/*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardLabel), {
                                        as: Link,
                                        to: parentTo,
                                        children: label
                                    }, label)),
                                date ? /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
                                    children: [
                                        "published on",
                                        " ",
                                        /*#__PURE__*/ (0, $iGQ0X.jsx)("time", {
                                            dateTime: (0, $lAMhd.default)(date, "yyyy-MM-dd"),
                                            children: (0, $lAMhd.default)(date, "MMM d, yyyy")
                                        })
                                    ]
                                }) : overline
                            ]
                        })
                    ]
                })
            }),
            description && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardBody), {
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)("p", {
                    children: description
                })
            }),
            footerContent && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardFooter), {
                children: footerContent
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardFigure), {
                src: imgSrc,
                isCoverOrFeatured: false,
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)("img", {
                    src: imgSrc,
                    alt: imgAlt,
                    loading: "lazy"
                })
            })
        ]
    });
    return CardContent;
}

});
parcelRegister("azHi1", function(module, exports) {

$parcel$export(module.exports, "CardList", function () { return $4a637bc9edd76c32$export$bb29c16f5612603e; });
$parcel$export(module.exports, "CardListGrid", function () { return $4a637bc9edd76c32$export$b00a90afeaf1eab4; });
$parcel$export(module.exports, "CardHeader", function () { return $4a637bc9edd76c32$export$5665775b26e26c5d; });
$parcel$export(module.exports, "CardHeadline", function () { return $4a637bc9edd76c32$export$de55224050bee4d7; });
$parcel$export(module.exports, "CardTitle", function () { return $4a637bc9edd76c32$export$474db65c3c394e1c; });
$parcel$export(module.exports, "CardOverline", function () { return $4a637bc9edd76c32$export$df063b277b1eb93; });
$parcel$export(module.exports, "CardMeta", function () { return $4a637bc9edd76c32$export$a8ae421c739691bf; });
$parcel$export(module.exports, "CardBody", function () { return $4a637bc9edd76c32$export$851de33184ecdac4; });
$parcel$export(module.exports, "CardFooter", function () { return $4a637bc9edd76c32$export$e9897d434e0741ee; });
$parcel$export(module.exports, "CardTopicsList", function () { return $4a637bc9edd76c32$export$7391ae7cd9297896; });
$parcel$export(module.exports, "CardLabel", function () { return $4a637bc9edd76c32$export$e13aaac4037b0914; });
$parcel$export(module.exports, "CardFigure", function () { return $4a637bc9edd76c32$export$448e687a629d6c89; });
$parcel$export(module.exports, "CardItem", function () { return $4a637bc9edd76c32$export$d14d08fa0d83d69d; });

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");

var $cvsoH = parcelRequire("cvsoH");

var $2tc6z = parcelRequire("2tc6z");

var $lCGzm = parcelRequire("lCGzm");

var $cLnMM = parcelRequire("cLnMM");

var $hQDsC = parcelRequire("hQDsC");
const $4a637bc9edd76c32$export$321b6557957bf9c6 = (0, $1mmhu.default).article`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  border-radius: ${(0, $15X7d.multiply)((0, $15X7d.themeVal)("shape.rounded"), 2)};
  box-shadow: ${(0, $15X7d.themeVal)("boxShadow.elevationD")};
  height: 100%;
  overflow: hidden;
  transition: all 0.24s ease-in-out 0s;
`;
const $4a637bc9edd76c32$export$bb29c16f5612603e = (0, $1mmhu.default).ol`
  ${(0, $15X7d.listReset)()}
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
const $4a637bc9edd76c32$export$b00a90afeaf1eab4 = (0, $1mmhu.default).ol`
  ${(0, $15X7d.listReset)()}
  grid-column: 1 / -1;
  display: grid;
  gap: ${(0, $lCGzm.variableGlsp)()};
  grid-template-columns: repeat(1, 1fr);

  ${(0, $15X7d.media).mediumUp`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${(0, $15X7d.media).largeUp`
    grid-template-columns: repeat(3, 1fr);
  `}

  > li {
    min-width: 0;
  }
`;
const $4a637bc9edd76c32$export$5665775b26e26c5d = (0, $1mmhu.default).header`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-end;
  padding: ${(0, $lCGzm.variableGlsp)()};
  gap: ${(0, $lCGzm.variableGlsp)()};
`;
const $4a637bc9edd76c32$export$de55224050bee4d7 = (0, $1mmhu.default).div`
  display: flex;
  flex-flow: column nowrap;
  gap: ${(0, $15X7d.glsp)(0.25)};
`;
const $4a637bc9edd76c32$export$9b6a647253f61c5f = (0, $1mmhu.default).div`
  /* styled-component */
`;
const $4a637bc9edd76c32$export$474db65c3c394e1c = (0, $1mmhu.default)((0, $hQDsC.VarHeading)).attrs({
    as: "h3",
    size: "small"
})`
  /* styled-component */
`;
const $4a637bc9edd76c32$export$df063b277b1eb93 = (0, $1mmhu.default)((0, $cvsoH.Overline))`
  order: -1;
  color: ${(0, $15X7d.themeVal)("color.base-400a")};

  > * {
    line-height: inherit;
  }

  i {
    ${(0, $15X7d.visuallyHidden)()}
  }
`;
const $4a637bc9edd76c32$export$a8ae421c739691bf = (0, $1mmhu.default).div`
  display: flex;
  gap: ${(0, $15X7d.glsp)(0.25)};

  a {
    color: inherit;
    pointer-events: all;

    &,
    &:visited {
      text-decoration: none;
      color: inherit;
    }

    &:hover {
      opacity: 0.64;
    }
  }

  > ${(0, $2tc6z.VerticalDivider)}:last-child {
    display: none;
  }

  > ${(0, $2tc6z.VerticalDivider)}:first-child {
    display: none;
  }
`;
const $4a637bc9edd76c32$export$851de33184ecdac4 = (0, $1mmhu.default).div`
  padding: ${(0, $lCGzm.variableGlsp)()};

  &:not(:first-child) {
    padding-top: 0;
    margin-top: ${(0, $lCGzm.variableGlsp)(-0.5)};
  }
`;
const $4a637bc9edd76c32$export$e9897d434e0741ee = (0, $1mmhu.default).div`
  display: flex;
  flex-flow: row nowrap;
  gap: ${(0, $lCGzm.variableGlsp)(0.5)};
  padding: ${(0, $lCGzm.variableGlsp)()};

  &:not(:first-child) {
    padding-top: 0;
    margin-top: ${(0, $lCGzm.variableGlsp)(-0.5)};
  }

  button {
    pointer-events: all;
  }
`;
const $4a637bc9edd76c32$export$7391ae7cd9297896 = (0, $1mmhu.default).dl`
  display: flex;
  gap: ${(0, $lCGzm.variableGlsp)(0.25)};
  max-width: 100%;
  width: 100%;
  overflow: hidden;
  mask-image: linear-gradient(
    to right,
    black calc(100% - 3rem),
    transparent 100%
  );

  > dt {
    ${(0, $15X7d.visuallyHidden)()}
  }
`;
const $4a637bc9edd76c32$export$e13aaac4037b0914 = (0, $1mmhu.default).span`
  position: absolute;
  z-index: 1;
  top: ${(0, $lCGzm.variableGlsp)()};
  right: ${(0, $lCGzm.variableGlsp)()};
  display: inline-block;
  vertical-align: top;
  color: ${(0, $15X7d.themeVal)("color.surface")};
  border-radius: ${(0, $15X7d.themeVal)("shape.ellipsoid")};
  padding: ${(0, $15X7d.glsp)(0.125, 0.5)};
  background: ${(0, $15X7d.themeVal)("color.base-400a")};
  pointer-events: auto;
  transition: all 0.24s ease 0s;

  &,
  &:visited {
    text-decoration: none;
  }

  &:hover {
    opacity: 0.64;
  }
`;
const $4a637bc9edd76c32$export$448e687a629d6c89 = (0, $1mmhu.default)((0, $cLnMM.Figure))`
  order: -1;
  width: 100%;
  ${(props)=>!props.isCoverOrFeatured && `aspect-ratio: 2/1;`}
  background: ${(props)=>props.src ? "none" : props.theme.color["primary-100"]};

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    mix-blend-mode: multiply;
    display: ${(props)=>props.src ? "block" : "none"};
  }
`;
const $4a637bc9edd76c32$export$d14d08fa0d83d69d = (0, $1mmhu.default)($4a637bc9edd76c32$export$321b6557957bf9c6)`
  ${({ isStateFocus: isStateFocus })=>isStateFocus && (0, $1mmhu.css)`
      box-shadow: ${(0, $15X7d.themeVal)("boxShadow.elevationC")};
      transform: translate(0, 0.125rem);
    `}
  ${({ isStateOver: isStateOver })=>isStateOver && (0, $1mmhu.css)`
      box-shadow: ${(0, $15X7d.themeVal)("boxShadow.elevationC")};
      transform: translate(0, 0.125rem);
    `}
  ${({ isStateActive: isStateActive })=>isStateActive && (0, $1mmhu.css)`
      box-shadow: ${(0, $15X7d.themeVal)("boxShadow.elevationB")};
      transform: translate(0, 0.125rem);
    `}
`;

});


parcelRegister("c8Swp", function(module, exports) {

$parcel$export(module.exports, "CoverCardItem", function () { return $145abca22c318d92$export$671e54f1529c8545; });
$parcel$export(module.exports, "default", function () { return $145abca22c318d92$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $lAMhd = parcelRequire("lAMhd");

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");

var $azHi1 = parcelRequire("azHi1");

var $8DoyF = parcelRequire("8DoyF");

var $lWOSY = parcelRequire("lWOSY");

var $lCGzm = parcelRequire("lCGzm");
const $145abca22c318d92$export$671e54f1529c8545 = (0, $1mmhu.default)((0, $azHi1.CardItem))`
  padding-top: ${(0, $lCGzm.variableGlsp)(2)};
  background: ${(0, $15X7d.themeVal)("color.base-400")};
  color: ${(0, $15X7d.themeVal)("color.surface")};
  justify-content: flex-end;

  ${(0, $azHi1.CardFigure)} {
    position: absolute;
    inset: 0;
    z-index: -1;
    background: ${(0, $15X7d.themeVal)("color.base-400")};
  }

  ${(0, $azHi1.CardOverline)} {
    color: ${(0, $15X7d.themeVal)("color.surface-400a")};
  }
`;
function $145abca22c318d92$export$2e2bcd8739ae039(props) {
    const { title: title, description: description, date: date, overline: overline, imgSrc: imgSrc, imgAlt: imgAlt, parentTo: parentTo, tagLabels: tagLabels, footerContent: footerContent, hideExternalLinkBadge: hideExternalLinkBadge } = props;
    let isExternalLink;
    if ("isExternalLink" in props) ({ isExternalLink: isExternalLink } = props);
    const { Link: Link } = (0, $lWOSY.useVedaUI)();
    const CardContent = /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardHeader), {
                children: /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $azHi1.CardHeadline), {
                    children: [
                        /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardTitle), {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $azHi1.CardOverline), {
                            as: "div",
                            children: [
                                hideExternalLinkBadge !== true && isExternalLink && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $8DoyF.ExternalLinkFlag), {}),
                                !isExternalLink && tagLabels && parentTo && tagLabels.map((label)=>/*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardLabel), {
                                        as: Link,
                                        to: parentTo,
                                        children: label
                                    }, label)),
                                date ? /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
                                    children: [
                                        "published on",
                                        " ",
                                        /*#__PURE__*/ (0, $iGQ0X.jsx)("time", {
                                            dateTime: (0, $lAMhd.default)(date, "yyyy-MM-dd"),
                                            children: (0, $lAMhd.default)(date, "MMM d, yyyy")
                                        })
                                    ]
                                }) : overline
                            ]
                        })
                    ]
                })
            }),
            description && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardBody), {
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)("p", {
                    children: description
                })
            }),
            footerContent && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardFooter), {
                children: footerContent
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardFigure), {
                src: imgSrc,
                isCoverOrFeatured: true,
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)("img", {
                    src: imgSrc,
                    alt: imgAlt,
                    loading: "lazy"
                })
            })
        ]
    });
    return CardContent;
}

});

parcelRegister("5p1nv", function(module, exports) {

$parcel$export(module.exports, "FeaturedCardItem", function () { return $a9d3e9a6dfefd02e$export$f7e9046806e2619f; });
$parcel$export(module.exports, "default", function () { return $a9d3e9a6dfefd02e$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $lAMhd = parcelRequire("lAMhd");

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");

var $azHi1 = parcelRequire("azHi1");

var $8DoyF = parcelRequire("8DoyF");

var $lWOSY = parcelRequire("lWOSY");

var $lCGzm = parcelRequire("lCGzm");
const $a9d3e9a6dfefd02e$export$f7e9046806e2619f = (0, $1mmhu.default)((0, $azHi1.CardItem))`
  padding-top: ${(0, $lCGzm.variableGlsp)()};
  color: ${(0, $15X7d.themeVal)("color.surface")};
  justify-content: flex-end;
  min-height: 16rem;

  ${(0, $15X7d.media).mediumUp`
          min-height: 28rem;
        `}

  ${(0, $azHi1.CardFigure)} {
    position: absolute;
    inset: 0;
    z-index: -1;
    background: ${(0, $15X7d.themeVal)("color.base-400")};
  }

  ${(0, $azHi1.CardTitle)} {
    font-size: ${(0, $lCGzm.variableBaseType)("1.5rem")};
    max-width: 52rem;
  }

  ${(0, $azHi1.CardOverline)} {
    color: ${(0, $15X7d.themeVal)("color.surface-400a")};
  }

  ${(0, $azHi1.CardBody)} {
    font-size: ${(0, $lCGzm.variableBaseType)("1rem")};
    max-width: 52rem;
  }
`;
function $a9d3e9a6dfefd02e$export$2e2bcd8739ae039(props) {
    const { title: title, description: description, date: date, overline: overline, imgSrc: imgSrc, imgAlt: imgAlt, parentTo: parentTo, tagLabels: tagLabels, footerContent: footerContent, hideExternalLinkBadge: hideExternalLinkBadge } = props;
    let isExternalLink;
    if ("isExternalLink" in props) ({ isExternalLink: isExternalLink } = props);
    const { Link: Link } = (0, $lWOSY.useVedaUI)();
    const CardContent = /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardHeader), {
                children: /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $azHi1.CardHeadline), {
                    children: [
                        /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardTitle), {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $azHi1.CardOverline), {
                            as: "div",
                            children: [
                                hideExternalLinkBadge !== true && isExternalLink && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $8DoyF.ExternalLinkFlag), {}),
                                !isExternalLink && tagLabels && parentTo && tagLabels.map((label)=>/*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardLabel), {
                                        as: Link,
                                        to: parentTo,
                                        children: label
                                    }, label)),
                                date ? /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
                                    children: [
                                        "published on",
                                        " ",
                                        /*#__PURE__*/ (0, $iGQ0X.jsx)("time", {
                                            dateTime: (0, $lAMhd.default)(date, "yyyy-MM-dd"),
                                            children: (0, $lAMhd.default)(date, "MMM d, yyyy")
                                        })
                                    ]
                                }) : overline
                            ]
                        })
                    ]
                })
            }),
            description && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardBody), {
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)("p", {
                    children: description
                })
            }),
            footerContent && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardFooter), {
                children: footerContent
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardFigure), {
                src: imgSrc,
                isCoverOrFeatured: true,
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)("img", {
                    src: imgSrc,
                    alt: imgAlt,
                    loading: "lazy"
                })
            })
        ]
    });
    return CardContent;
}

});

parcelRegister("e3PN2", function(module, exports) {

$parcel$export(module.exports, "HorizontalInfoCardItem", function () { return $bc3f612a7af729bd$export$5ff89e61b11eda0d; });
$parcel$export(module.exports, "default", function () { return $bc3f612a7af729bd$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");

var $azHi1 = parcelRequire("azHi1");

var $lCGzm = parcelRequire("lCGzm");

var $fcETu = parcelRequire("fcETu");
const $bc3f612a7af729bd$var$HorizontalCard = (0, $1mmhu.default).div`
  display: flex;
  height: inherit;
`;
const $bc3f612a7af729bd$var$CardImage = (0, $1mmhu.default).div`
  min-width: 10rem;
  width: 10rem;
  height: 100%;
  background: ${(0, $15X7d.themeVal)("color.primary-100")};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const $bc3f612a7af729bd$var$CardContent = (0, $1mmhu.default).div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem;
`;
const $bc3f612a7af729bd$export$9b1cabb95df82258 = (0, $1mmhu.css)`
  height: 10rem;
  color: ${(0, $15X7d.themeVal)("color.base-800")};

  ${(0, $azHi1.CardTitle)} {
    font-size: ${(0, $lCGzm.variableBaseType)("0.7rem")};
  }

  #description {
    font-size: ${(0, $lCGzm.variableBaseType)("0.6rem")};
    height: 3rem;
    margin: 0.5rem 0;
    overflow: hidden;
    text-overflow: ellipsis;

    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;

    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
  }

  #tags {
    display: flex;
    flex-wrap: wrap;
    gap: ${(0, $15X7d.glsp)(0.5)};
  }
`;
const $bc3f612a7af729bd$export$5ff89e61b11eda0d = (0, $1mmhu.default)((0, $azHi1.CardItem))`
  ${$bc3f612a7af729bd$export$9b1cabb95df82258}
`;
function $bc3f612a7af729bd$export$2e2bcd8739ae039(props) {
    const { title: title, description: description, imgSrc: imgSrc, imgAlt: imgAlt, tagLabels: tagLabels } = props;
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)($bc3f612a7af729bd$var$HorizontalCard, {
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)($bc3f612a7af729bd$var$CardImage, {
                children: imgSrc && /*#__PURE__*/ (0, $iGQ0X.jsx)("img", {
                    src: imgSrc,
                    alt: imgAlt,
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsxs)($bc3f612a7af729bd$var$CardContent, {
                children: [
                    /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $azHi1.CardTitle), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $iGQ0X.jsx)("div", {
                        id: "description",
                        children: /*#__PURE__*/ (0, $iGQ0X.jsx)("p", {
                            children: description
                        })
                    }),
                    tagLabels && tagLabels.length > 0 && /*#__PURE__*/ (0, $iGQ0X.jsx)("div", {
                        id: "tags",
                        children: tagLabels.map((label)=>/*#__PURE__*/ (0, $iGQ0X.jsx)((0, $fcETu.Pill), {
                                variation: "primary",
                                children: label
                            }, label))
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("fcETu", function(module, exports) {

$parcel$export(module.exports, "Pill", function () { return $b32ab1eed42c4995$export$d2cf3038149dd1b5; });

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");
const $b32ab1eed42c4995$var$renderPillVariation = ({ variation: variation })=>{
    switch(variation){
        case "achromic":
            return (0, $1mmhu.css)`
        color: ${(0, $15X7d.themeVal)("color.surface")};
        background: ${(0, $15X7d.themeVal)("color.surface-100a")};
      `;
        case "warning":
            return (0, $1mmhu.css)`
        color: ${(0, $15X7d.themeVal)("color.danger-500")};
        background: ${(0, $15X7d.themeVal)("color.danger-200a")};
      `;
        case "primary":
        default:
            return (0, $1mmhu.css)`
        color: ${(0, $15X7d.themeVal)("color.primary")};
        background: ${(0, $15X7d.themeVal)("color.primary-100a")};
      `;
    }
};
const $b32ab1eed42c4995$export$d2cf3038149dd1b5 = (0, $1mmhu.default).span`
  display: inline-flex;
  vertical-align: top;
  border-radius: ${(0, $15X7d.themeVal)("shape.ellipsoid")};
  padding: ${(0, $15X7d.glsp)(0.125, 0.75)};
  transition: all 0.24s ease 0s;
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-weight: ${(0, $15X7d.themeVal)("type.base.bold")};
  white-space: nowrap;

  /* stylelint-disable-next-line selector-type-no-unknown */
  ${$b32ab1eed42c4995$var$renderPillVariation}

  :is(a) {
    pointer-events: auto;

    &,
    &:visited {
      text-decoration: none;
    }

    &:hover {
      opacity: 0.64;
    }
  }
`;

});


parcelRegister("lt7JL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84aae662dbc087cd$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $eRb0f = parcelRequire("eRb0f");
function $84aae662dbc087cd$export$2e2bcd8739ae039(props) {
    const { heading: heading, layout: layout, gridLayout: gridLayout, imgSrc: imgSrc, imgAlt: imgAlt, description: description, footer: footer, cardLabel: cardLabel } = props;
    const defaultLayout = layout ? layout : "flagDefault";
    const defaultGridLayout = gridLayout ? gridLayout : {
        desktop: {
            col: 12
        }
    }; // Full Width
    const cardHeader = {
        element: /*#__PURE__*/ (0, $iGQ0X.jsx)("h2", {
            className: "usa-card__heading card-header",
            children: heading
        })
    };
    const cardMedia = {
        element: /*#__PURE__*/ (0, $iGQ0X.jsx)("img", {
            src: imgSrc,
            alt: imgAlt
        })
    };
    const cardBody = {
        element: /*#__PURE__*/ (0, $iGQ0X.jsx)("p", {
            className: "font-body-xs",
            children: description
        })
    };
    const cardFooter = {
        element: footer
    };
    const cardProps = {
        layout: defaultLayout,
        gridLayout: defaultGridLayout,
        media: cardMedia,
        header: cardHeader,
        body: cardBody,
        footer: cardFooter,
        cardLabel: cardLabel
    };
    return /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $eRb0f.default), {
        ...cardProps
    });
}

});
parcelRegister("eRb0f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $788da96e3e2dd7c8$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $gfxhZ = parcelRequire("gfxhZ");

var $1unwV = parcelRequire("1unwV");

function $788da96e3e2dd7c8$export$2e2bcd8739ae039({ id: id, layout: layout, media: media, header: header, footer: footer, gridLayout: gridLayout, cardLabel: cardLabel, style: style, body: body, className: className, isCardFocusable: isCardFocusable }) {
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $1unwV.USWDSCardComponent), {
        id: id,
        layout: layout,
        gridLayout: gridLayout,
        style: style,
        className: className,
        tabIndex: isCardFocusable ? 0 : undefined,
        children: [
            header && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSCardHeader), {
                className: header.className,
                children: header.element
            }),
            media && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSCardMedia), {
                className: media.className,
                children: media.element
            }),
            cardLabel && /*#__PURE__*/ (0, $iGQ0X.jsx)("div", {
                className: "position-absolute padding-2",
                children: (0, $gfxhZ.createCardLabel)(cardLabel)
            }),
            body && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSCardBody), {
                className: body.className,
                children: body.element
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSCardFooter), {
                className: footer.className,
                children: footer.element
            })
        ]
    });
}

});
parcelRegister("gfxhZ", function(module, exports) {

$parcel$export(module.exports, "createCardLabel", function () { return $e71c817497145403$export$2a564c26e3c9b745; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $lFow0 = parcelRequire("lFow0");
const $e71c817497145403$export$2a564c26e3c9b745 = (type)=>{
    const item = $e71c817497145403$var$mapper[type];
    return /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $lFow0.Tags), {
        icon: item.svg,
        items: [
            item.title
        ]
    });
};
const $e71c817497145403$export$b04be29aa201d4f5 = {
    Data_collection: "data_collection",
    Story: "story",
    Topic: "topic",
    Widget: "widget"
};
const $e71c817497145403$export$87fa427ae5b44ef0 = {
    data_collection: "Data Collection",
    story: "Story",
    topic: "Topic",
    widget: "Widget"
};
const $e71c817497145403$export$6722f2abd5aa752a = {
    data_collection: /*#__PURE__*/ (0, $iGQ0X.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
                d: "M10.3125 7.92613L6.00003 10.441L1.68753 7.92613C1.60214 7.88362 1.50376 7.87524 1.41242 7.9027C1.32107 7.93016 1.24363 7.9914 1.19584 8.07395C1.14806 8.1565 1.13352 8.25416 1.1552 8.34705C1.17688 8.43993 1.23314 8.52107 1.31253 8.57394L5.81253 11.1989C5.86987 11.2324 5.93505 11.25 6.00143 11.25C6.06781 11.25 6.133 11.2324 6.19034 11.1989L10.6903 8.57394C10.7336 8.54949 10.7715 8.51669 10.8019 8.47746C10.8324 8.43823 10.8547 8.39334 10.8677 8.3454C10.8806 8.29746 10.884 8.24743 10.8774 8.1982C10.8709 8.14897 10.8546 8.10153 10.8296 8.05864C10.8046 8.01574 10.7713 7.97824 10.7317 7.94831C10.6921 7.91838 10.6469 7.89662 10.5988 7.8843C10.5507 7.87197 10.5006 7.86932 10.4515 7.8765C10.4023 7.88368 10.3551 7.90055 10.3125 7.92613Z",
                fill: "#565C65"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
                d: "M10.3125 5.67613L6.00003 8.19097L1.68753 5.67613C1.60214 5.63362 1.50376 5.62524 1.41242 5.6527C1.32107 5.68016 1.24363 5.7414 1.19584 5.82395C1.14806 5.9065 1.13352 6.00416 1.1552 6.09705C1.17688 6.18993 1.23314 6.27107 1.31253 6.32394L5.81253 8.94894C5.86987 8.98238 5.93505 9 6.00143 9C6.06781 9 6.133 8.98238 6.19034 8.94894L10.6903 6.32394C10.7336 6.29949 10.7715 6.26669 10.8019 6.22746C10.8324 6.18823 10.8547 6.14334 10.8677 6.0954C10.8806 6.04746 10.884 5.99743 10.8774 5.9482C10.8709 5.89897 10.8546 5.85153 10.8296 5.80864C10.8046 5.76574 10.7713 5.72824 10.7317 5.69831C10.6921 5.66838 10.6469 5.64662 10.5988 5.6343C10.5507 5.62197 10.5006 5.61932 10.4515 5.6265C10.4023 5.63368 10.3551 5.65055 10.3125 5.67613Z",
                fill: "#565C65"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
                d: "M1.31249 4.07387L5.81249 6.69887C5.86983 6.73231 5.93502 6.74993 6.0014 6.74993C6.06778 6.74993 6.13297 6.73231 6.19031 6.69887L10.6903 4.07387C10.7469 4.04084 10.7939 3.99356 10.8265 3.93673C10.8592 3.87989 10.8763 3.8155 10.8763 3.74996C10.8763 3.68442 10.8592 3.62003 10.8265 3.5632C10.7939 3.50637 10.7469 3.45908 10.6903 3.42606L6.19031 0.801056C6.13297 0.767619 6.06778 0.75 6.0014 0.75C5.93502 0.75 5.86983 0.767619 5.81249 0.801056L1.31249 3.42606C1.25589 3.45908 1.20892 3.50637 1.17628 3.5632C1.14364 3.62003 1.12646 3.68442 1.12646 3.74996C1.12646 3.8155 1.14364 3.87989 1.17628 3.93673C1.20892 3.99356 1.25589 4.04084 1.31249 4.07387Z",
                fill: "#565C65"
            })
        ]
    }),
    story: /*#__PURE__*/ (0, $iGQ0X.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
            d: "M8.625 1.5H3.375C3.17609 1.5 2.98532 1.57902 2.84467 1.71967C2.70402 1.86032 2.625 2.05109 2.625 2.25V10.5C2.62503 10.5669 2.64298 10.6326 2.67696 10.6903C2.71095 10.7479 2.75975 10.7954 2.81829 10.8278C2.87684 10.8603 2.94299 10.8764 3.00989 10.8747C3.07679 10.8729 3.142 10.8533 3.19875 10.8178L6 9.06703L8.80172 10.8178C8.85846 10.8532 8.92362 10.8727 8.99045 10.8744C9.05728 10.8761 9.12335 10.8599 9.18182 10.8275C9.24029 10.7951 9.28903 10.7476 9.32299 10.69C9.35696 10.6325 9.37491 10.5669 9.375 10.5V2.25C9.375 2.05109 9.29598 1.86032 9.15533 1.71967C9.01468 1.57902 8.82391 1.5 8.625 1.5Z",
            fill: "#565C65"
        })
    }),
    topic: /*#__PURE__*/ (0, $iGQ0X.jsx)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
            d: "M5 0.125C4.03582 0.125 3.09329 0.410914 2.2916 0.946586C1.48991 1.48226 0.865067 2.24363 0.496089 3.13442C0.127112 4.02521 0.030571 5.00541 0.218674 5.95107C0.406777 6.89672 0.871076 7.76536 1.55286 8.44715C2.23464 9.12893 3.10328 9.59323 4.04894 9.78133C4.99459 9.96943 5.97479 9.87289 6.86558 9.50391C7.75637 9.13494 8.51775 8.51009 9.05342 7.7084C9.58909 6.90671 9.875 5.96418 9.875 5C9.87351 3.70753 9.35942 2.46842 8.4455 1.5545C7.53159 0.640581 6.29248 0.126489 5 0.125ZM8.67313 3.125H7.00203C6.79159 2.35293 6.43691 1.62766 5.95672 0.9875C6.5369 1.12687 7.08008 1.39005 7.54902 1.75899C8.01797 2.12794 8.40159 2.59392 8.6736 3.125H8.67313ZM9.125 5C9.12533 5.38042 9.07279 5.75904 8.96891 6.125H7.16375C7.27875 5.37941 7.27875 4.62059 7.16375 3.875H8.96891C9.07279 4.24096 9.12533 4.61958 9.125 5ZM5 1.01562C5.56153 1.61681 5.97837 2.33827 6.21875 3.125H3.78125C4.02139 2.33816 4.43826 1.61665 5 1.01562ZM3.78125 6.875H6.21875C5.97862 7.66184 5.56174 8.38335 5 8.98438C4.43848 8.38319 4.02163 7.66173 3.78125 6.875ZM3.59844 6.125C3.46969 5.38053 3.46969 4.61947 3.59844 3.875H6.40531C6.53406 4.61947 6.53406 5.38053 6.40531 6.125H3.59844ZM5.9586 9.0125C6.43878 8.37234 6.79346 7.64707 7.00391 6.875H8.67547C8.40327 7.40628 8.01936 7.87239 7.55007 8.24135C7.08079 8.6103 6.53724 8.87337 5.95672 9.0125H5.9586Z",
            fill: "#565C65"
        })
    }),
    widget: /*#__PURE__*/ (0, $iGQ0X.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
            d: "M4.68751 5.45766C4.74453 5.42474 4.79187 5.37738 4.82479 5.32036C4.8577 5.26334 4.87502 5.19865 4.87501 5.13281V1.75781C4.87467 1.69803 4.86005 1.63919 4.83235 1.5862C4.80466 1.53321 4.76469 1.48762 4.7158 1.45321C4.6669 1.41881 4.61048 1.3966 4.55125 1.38843C4.49203 1.38026 4.43171 1.38637 4.37532 1.40625C3.28078 1.79363 2.36031 2.55874 1.77939 3.56403C1.19847 4.56933 0.995191 5.74887 1.2061 6.89063C1.21703 6.94967 1.24198 7.00522 1.27885 7.05261C1.31572 7.10001 1.36344 7.13785 1.41798 7.16297C1.46713 7.18595 1.52075 7.1978 1.57501 7.19766C1.64083 7.19768 1.70549 7.18038 1.76251 7.1475L4.68751 5.45766ZM4.12501 2.32594V4.91625L1.88063 6.21141C1.87501 6.14062 1.87501 6.06938 1.87501 6C1.87567 5.23986 2.08608 4.49464 2.48307 3.84639C2.88005 3.19815 3.44822 2.67202 4.12501 2.32594ZM10.875 6C10.8754 7.07022 10.5236 8.11082 9.87385 8.96125C9.22413 9.81168 8.31262 10.4247 7.27995 10.7057C6.24728 10.9867 5.15084 10.92 4.1598 10.516C3.16876 10.112 2.3382 9.39317 1.79626 8.47031C1.77099 8.42769 1.75443 8.38048 1.74752 8.33141C1.74061 8.28234 1.74349 8.23239 1.756 8.18445C1.76851 8.1365 1.7904 8.09151 1.8204 8.05207C1.8504 8.01264 1.88792 7.97954 1.93079 7.95469L5.62501 5.80453V1.5C5.62501 1.40054 5.66452 1.30516 5.73484 1.23483C5.80517 1.16451 5.90055 1.125 6.00001 1.125C6.85073 1.12543 7.68654 1.34838 8.42446 1.77169C9.16239 2.19501 9.77675 2.80397 10.2066 3.53813C10.2117 3.54563 10.2164 3.55313 10.2211 3.56109C10.2258 3.56906 10.2305 3.57844 10.2347 3.58687C10.6553 4.32149 10.8761 5.15349 10.875 6Z",
            fill: "#565C65"
        })
    })
};
const $e71c817497145403$var$mapper = {
    data_collection: {
        title: "Data Collection",
        svg: $e71c817497145403$export$6722f2abd5aa752a.data_collection
    },
    story: {
        title: "Story",
        svg: $e71c817497145403$export$6722f2abd5aa752a.story
    },
    topic: {
        title: "Topic",
        svg: $e71c817497145403$export$6722f2abd5aa752a.topic
    }
};

});
parcelRegister("lFow0", function(module, exports) {

$parcel$export(module.exports, "Tags", function () { return $7a6394113ac31e18$export$b72686b556e29ca6; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $1unwV = parcelRequire("1unwV");

const $7a6394113ac31e18$export$b72686b556e29ca6 = ({ items: items, icon: icon, classNames: classNames = "default-veda-tag text-no-uppercase" })=>{
    return /*#__PURE__*/ (0, $iGQ0X.jsx)("div", {
        style: {
            display: "flex",
            flexWrap: "wrap"
        },
        children: items.map((t)=>/*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSTag), {
                className: classNames,
                children: icon ? /*#__PURE__*/ (0, $iGQ0X.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    className: "label-tag",
                    children: [
                        icon,
                        /*#__PURE__*/ (0, $iGQ0X.jsx)("p", {
                            children: t
                        })
                    ]
                }) : t
            }, t))
    });
};

});




parcelRegister("1fwGm", function(module, exports) {

$parcel$export(module.exports, "ElementInteractive", function () { return $0e908b2c112a126c$export$5898f455345088bd; });

var $iGQ0X = parcelRequire("iGQ0X");

var $9kFno = parcelRequire("9kFno");

var $1JWl8 = parcelRequire("1JWl8");

var $1mmhu = parcelRequire("1mmhu");
const $0e908b2c112a126c$export$e6dfd72ab29f8598 = (0, $1mmhu.default).div`
  position: relative;
  z-index: 1;

  > *:not(a) {
    pointer-events: none;
  }
`;
const $0e908b2c112a126c$var$InteractiveLink = (0, $1mmhu.default).a`
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: auto;
  font-size: 0;
  margin: 0;
`;
const $0e908b2c112a126c$export$5898f455345088bd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kFno))).forwardRef(function ElementInteractiveFwd(props, ref) {
    const { linkProps: linkProps = {}, linkLabel: linkLabel = "View", children: children, onClick: onClick, ...rest } = props;
    const [isStateOver, setStateOver] = (0, $9kFno.useState)(false);
    const [isStateActive, setStateActive] = (0, $9kFno.useState)(false);
    const [isStateFocus, setStateFocus] = (0, $9kFno.useState)(false);
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)($0e908b2c112a126c$export$e6dfd72ab29f8598, {
        ref: ref,
        ...rest,
        isStateOver: isStateOver,
        isStateActive: isStateActive,
        isStateFocus: isStateFocus,
        onFocus: (0, $9kFno.useCallback)(()=>setStateFocus(true), []),
        onBlur: (0, $9kFno.useCallback)(()=>setStateFocus(false), []),
        onMouseEnter: (0, $9kFno.useCallback)(()=>setStateOver(true), []),
        onMouseLeave: (0, $9kFno.useCallback)(()=>{
            setStateOver(false);
            setStateActive(false);
        }, []),
        onClick: onClick,
        children: [
            children,
            /*#__PURE__*/ (0, $iGQ0X.jsx)($0e908b2c112a126c$var$InteractiveLink, {
                ...linkProps,
                onMouseDown: (0, $9kFno.useCallback)(()=>setStateActive(true), []),
                onMouseUp: (0, $9kFno.useCallback)(()=>setStateActive(false), []),
                onFocus: (0, $9kFno.useCallback)(()=>setStateFocus(true), []),
                onBlur: (0, $9kFno.useCallback)(()=>setStateFocus(false), []),
                children: linkLabel
            })
        ]
    });
});
$0e908b2c112a126c$export$5898f455345088bd.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1JWl8))).node.isRequired,
    linkLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1JWl8))).string.isRequired,
    linkProps: (0, (/*@__PURE__*/$parcel$interopDefault($1JWl8))).object,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1JWl8))).func
}; /**
🍀 FULL EXAMPLE CODE

import { Link } from 'react-router-dom'
import { ElementInteractive, Wrapper } from './element-interactive';

const WrapperElement = styled(Wrapper).attrs({ as: 'article' })`
  ${({ isStateFocus }) => isStateFocus && css``}
  ${({ isStateOver }) => isStateOver && css``}
  ${({ isStateActive }) => isStateActive && css``}
`;

function MyComponent() {
  return (
    <ElementInteractive
      as={WrapperElement}
      linkLabel='View more'
      linkProps={{
        as: Link,
        to: '/member/123'
      }}
    >
      <p>Content for this item</p>
      <button>click</button>
    </ElementInteractive>
  );
}
*/ 

});



//# sourceMappingURL=home.13531759.js.map
